export default __webpack_public_path__ + "static/media/landschedule.d1e7fe41.svg";